import React from 'react'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import _ from 'lodash'

import { setActionValue, saveActionDetail, updateActionsErrors, updateModalError as updateDetailsModalError } from 'redux/smartchat/details/actions'
import { updateAlternatives, setAlternativesActionValue, updateAlternativesActionsErrors, updateModalError as updateAlternativesModalError } from 'redux/smartchat/alternatives/actions'
import ActionsViewUI from './ActionsViewUI'
import { typesData } from 'components/SmartChatView/utils'

const ActionsView = ({ actionType, renderType, previewActionRef, previewActionDetail, currentValue, dataWay }) => {
  const { header, currentProcess, actionDetail, actionsErrors } = useSelector(store => ({
    header: store.smartchatHeader.header,
    currentProcess: store.smartchatHeader.currentProcess,
    actionDetail: dataWay?.type === 'alternatives'
      ? store.smartchatAlternatives.alternativesActionDetail.find(actionDetail => actionDetail.alternativesId === dataWay.alternativesId)?.actionDetail || {}
      : store.smartchatDetails.actionDetail,
    actionsErrors: dataWay?.type === 'alternatives'
      ? store.smartchatAlternatives.alternativesActionsErrors.find(actionsErrors => actionsErrors.alternativesId === dataWay.alternativesId) || {}
      : store.smartchatDetails.actionsErrors
  }), shallowEqual)
  const dispatch = useDispatch()

  const onChange = (actionValue) => {
    // Verifica que existan nuevos datos
    if (_.isEqual(actionDetail.eventData, actionValue)) return
    if (_.isEqual(actionDetail.actionProperties, actionValue)) return

    // Limpieza de errores
    let actionType = actionDetail.eventType || actionDetail.actionSubtype || previewActionDetail.eventType || previewActionDetail.actionSubtype
    let _actionsErrors = _.cloneDeep(actionsErrors)
    delete _actionsErrors[actionType]
    if (!dataWay) {
      dispatch(updateActionsErrors(_actionsErrors))
      dispatch(updateDetailsModalError(null))
    } else {
      if (dataWay.type === 'alternatives') {
        dispatch(updateAlternativesActionsErrors({ alternativesId: dataWay.alternativesId, actionsErrors: _actionsErrors }))
        dispatch(updateAlternativesModalError(null))
      }
    }

    // Si los datos vienen del modal (Se almacena en Redux)
    if (renderType === 'action') {
      if (!dataWay) {
        dispatch(setActionValue(actionValue))
      } else {
        dataWay.type === 'alternatives' && dispatch(setAlternativesActionValue({ alternativesId: dataWay.alternativesId, actionValue }))
      }
    }

    // Si los datos vienen del preview (Se envía al backend directamente)
    if (renderType === 'preview') {
      let _previewActionDetail = _.cloneDeep(previewActionDetail)

      if (previewActionRef.actionType === 'botAction') {
        _previewActionDetail.eventData = actionValue
      }
      if (typesData.clientOperatorActionTypes.includes(previewActionRef.actionType)) {
        _previewActionDetail.actionProperties = actionValue
      }

      if (!dataWay) {
        dispatch(saveActionDetail({ previewActionRef: { ...previewActionRef, mode: 'update' }, previewActionDetail: _previewActionDetail }))
      } else {
        dataWay.type === 'alternatives' && dispatch(updateAlternatives({ alternativesId: dataWay.alternativesId, modalActionRef: previewActionRef, actionDetail: _previewActionDetail }))
      }
    }
  }

  return (
    <ActionsViewUI
      currentProcess={currentProcess}
      actionType={actionType}
      renderType={renderType}
      previewActionRef={previewActionRef}
      previewActionDetail={previewActionDetail}
      currentValue={currentValue}
      dataForField={{ header }}
      dataWay={dataWay}
      onChange={onChange}
      dispatch={dispatch}
      actionsErrors={actionsErrors}
    />
  )
}

export default ActionsView
